import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { LiteSlateEditor } from "../../lite-slate-editor"
import { EditableImage } from "../../../header/editable/editable-image"
import { getRatio } from "../../components/column-ratio"
import { ConditionalLink } from "../../../shared/conditional-link"
import { GAP_IF_UNDEFINED } from "./constants"

const DEFAULT_IMAGE_URL =
  "https://cdn.convertkit.com/assets/layout-placeholder-v2.png"

const styles = `
  @media only screen and (max-width:600px) {
    .ck-ctaleftimageright td {
      display: block !important;
      width: 100% !important;
      padding: 0 !important;
    }

    .ck-ctaleftimageright img {
      margin-top: 18px !important;
    }
  }
`

export function CTALeftImageRight({ block_id, properties }) {
  const { children } = useBlocks(block_id)

  const containerStyle = {
    backgroundColor: properties.backgroundColor,
    paddingTop: properties.paddingTop || properties.verticalPadding,
    paddingRight: properties.paddingRight || properties.horizontalPadding,
    paddingBottom: properties.paddingBottom || properties.verticalPadding,
    paddingLeft: properties.paddingLeft || properties.horizontalPadding,
    borderTopLeftRadius: properties.borderTopLeftRadius,
    borderTopRightRadius: properties.borderTopRightRadius,
    borderBottomLeftRadius: properties.borderBottomLeftRadius,
    borderBottomRightRadius: properties.borderBottomRightRadius,
    borderWidth: properties.borderWidth,
    borderTopWidth: properties.borderTopWidth,
    borderRightWidth: properties.borderRightWidth,
    borderBottomWidth: properties.borderBottomWidth,
    borderLeftWidth: properties.borderLeftWidth,
    borderColor: properties.borderColor,
    borderStyle: "solid"
  }

  const imageBorderRadius = properties.borderTopLeftRadius * 0.5
  const gap =
    (properties.gap === undefined ? GAP_IF_UNDEFINED : properties.gap) / 2

  return (
    <div
      className="ck-ctaleftimageright ck-layout-block-template"
      style={containerStyle}
      bgcolor={properties.backgroundColor}
    >
      <table
        border="0"
        cellPadding="0"
        cellSpacing="0"
        width="100%"
        bgcolor={properties.backgroundColor}
      >
        <tbody>
          <tr>
            <td
              width={getRatio(properties.columnRatio, "left")}
              style={{ paddingRight: gap, verticalAlign: "middle" }}
            >
              <LiteSlateEditor block_id={children[0].block_id} />
            </td>
            <td
              width={getRatio(properties.columnRatio, "right")}
              style={{ paddingLeft: gap, verticalAlign: "top" }}
            >
              <ConditionalLink href={properties.imageUrl}>
                <EditableImage
                  name="image"
                  src={properties.image || DEFAULT_IMAGE_URL}
                  alt={properties.alt}
                  width="100%"
                  height="auto"
                  style={{
                    maxWidth: "100%",
                    display: "block",
                    borderRadius: imageBorderRadius
                  }}
                />
              </ConditionalLink>
            </td>
          </tr>
        </tbody>
      </table>
      <style>{styles}</style>
    </div>
  )
}
